module.exports = __webpack_public_path__ + "static/img/84-1.3936f0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/84-1.jpg
// module id = M+Ec
// module chunks = 0